module.exports = __webpack_public_path__ + "static/inspection-00d00094f17528d641d8a4ef3768795f.png";